import Swal from "sweetalert2";

const Termdata = () => {
    Swal.fire({
      title: "POLITICA DE TRATAMIENTO DE DATOS PERSONALES",
      html: `
      <html>
      <head>
        <meta http-equiv="content-type" content="text/html; charset=utf-8"/>
        <title></title>
        <meta name="generator" content="LibreOffice 7.4.1.2 (Linux)"/>
        <meta name="author" content="Sandra Viviana Victoria Cabrera"/>
        <meta name="created" content="2022-09-06T16:06:00"/>
        <meta name="changedby" content="Sandra Viviana Victoria Cabrera"/>
        <meta name="changed" content="2022-09-06T16:07:00"/>
        <meta name="AppVersion" content="15.0000"/>
        <style type="text/css">
          @page { size: 8.5in 11in; margin-left: 1.18in; margin-right: 1.18in; margin-top: 0.98in; margin-bottom: 0.98in }
          p { line-height: 115%; text-align: left; orphans: 2; widows: 2; margin-bottom: 0.1in; direction: ltr; background: transparent }
          a:link { color: #0000ff; text-decoration: underline }
        </style>
      </head>
      <body lang="es-CO" link="#0000ff" vlink="#800000" dir="ltr"><p align="justify" style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.1in; background: #ffffff">
      <font color="#555555"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Protección
      Datos Personales</font></font></font></p>
      <p align="justify" style="line-height: 100%; margin-top: 0.21in; margin-bottom: 0.1in; background: #ffffff">
      <font color="#555555"><font face="Arial, serif"><font size="3" style="font-size: 12pt">POLITICA
      DE TRATAMIENTO DE DATOS PERSONALES</font></font></font></p>
      <p align="justify" style="line-height: 100%; margin-bottom: 0.1in; background: #ffffff"><a name="_GoBack"></a>
      <font color="#43484e"><font face="Arial, serif"><font size="3" style="font-size: 12pt">EMCALI
      EICE ESP en cumplimiento de la ley 1581 de 2012, del Decreto
      Reglamentario 1377 de 2013 y el Decreto Reglamentario 1074 de 2015, y
      las demás normas que lo modifiquen, adicionen o complementen, en su
      posición de Responsable de los Datos, implementa la presente
      política para el tratamiento de Datos Personales, con el objetivo de
      mantener la seguridad y privacidad de los mismos.</font></font></font></p>
      <p align="justify" style="line-height: 100%; margin-bottom: 0.1in; background: #ffffff">
      <font color="#43484e"><font face="Arial, serif"><font size="3" style="font-size: 12pt">De
      acuerdo con sus funciones de prestador de servicios públicos
      domiciliarios, de tecnologías de la información y las
      comunicaciones, actividades complementarias e inherentes, se
      compromete a dar el tratamiento adecuado en la recolección,
      almacenamiento, uso, circulación o supresión a los datos personales
      que le sean suministrados e incorporados en las bases de datos y
      archivos de EMCALI EICE ESP, con la finalidad específica para la
      prestación de los servicios de su competencia y demás actividades
      que se enuncian en el aviso de privacidad que se encuentra en la
      página web www.emcali.com.co. El anterior tratamiento puede ser
      realizado directamente por EMCALI EICE ESP y/o por un tercero que sea
      legalmente delegado para ello.</font></font></font></p>
      <p align="justify" style="line-height: 100%; margin-bottom: 0.1in; background: #ffffff">
      <font color="#43484e"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Los
      titulares de los datos personales registrados en las bases de datos
      de EMCALI EICE ESP, de conformidad con lo dispuesto en la Ley 1581 de
      2012 y en las normas que la modifiquen, adicionen o complementen,
      tendrán derecho en forma gratuita a conocer, actualizar, rectificar,
      solicitar la supresión de sus datos personales y/o revocar la
      autorización mediante comunicación verbal o escrita presentada a
      través de los siguientes canales:</font></font></font></p>
      <ol>
        <li><p align="justify" style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0in; background: #ffffff">
        <font color="#43484e"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Página
        web:&nbsp;</font></font></font><a href="http://www.emcali.com.co/" target="www.emcali.com.co"><font color="#777777"><font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>www.emcali.com.co</b></font></font></font></a></p>
        <li><p align="justify" style="line-height: 100%; margin-bottom: 0in; background: #ffffff">
        <font color="#43484e"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Oficinas
        de Atención: Centros de Atención al Cliente CAP´s y Centros de
        Atención Local Integrada CALI's.</font></font></font></p>
        <li><p align="justify" style="line-height: 100%; margin-bottom: 0in; background: #ffffff">
        <font color="#43484e"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Línea
        de atención gratuita: Contact Center 177 ó (2) 5240177</font></font></font></p>
        <li><p align="justify" style="line-height: 100%; margin-bottom: 0.19in; background: #ffffff">
        <font color="#43484e"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Edificio
        CAM Torre EMCALI, Av. 2 Norte entre Calles 10 y 11, Cali-Valle del
        Cauca.</font></font></font></p>
      </ol>
      <p align="justify" style="line-height: 100%; margin-bottom: 0.1in; background: #ffffff">
      <font color="#43484e"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Las
      consultas y reclamos que presenten los titulares de los datos
      personales serán atendidas y tramitadas por la Dirección de
      Atención al Cliente, de acuerdo a los términos y procedimientos
      establecidos en los art. 14 y 15 de la Ley 1581 de 2012, y en las
      normas que la adicionen, modifiquen o complementen.</font></font></font></p>
      <p align="justify" style="line-height: 100%; margin-bottom: 0.1in; background: #ffffff">
      <font color="#43484e"><font face="Arial, serif"><font size="3" style="font-size: 12pt">Las
      consultas serán atendidas en un término máximo de diez (10) días
      hábiles contados a partir de la fecha de recibo de la misma y los
      reclamos serán atendidos en un término máximo de quince (15) días
      hábiles contados a partir del día siguiente a la fecha de su recibo
      y podrán ser presentados en cualquiera de los canales de atención:
      Línea telefónica (177 ó 5240177), formulario electrónico de PQR
      en www.emcali.com.co, y oficinas físicas de atención al usuario.
      Mayor información en nuestro portal corporativo, línea 177 y
      carteleras de los puntos de atención.</font></font></font></p>
      <p align="justify" style="line-height: 100%; margin-bottom: 0.1in; background: #ffffff">
      <font color="#43484e"><font face="Arial, serif"><font size="3" style="font-size: 12pt">La
      presente política de tratamiento de datos personales entra en
      vigencia a partir de la fecha de su publicación y la correspondiente
      a las bases de datos estará sujeta al cumplimiento de lo dispuesto
      en la Ley General de Archivos y las Tablas de Retención Documental
      de EMCALI EICE ESP.</font></font></font></p>
      <p align="justify" style="line-height: 108%; margin-bottom: 0.11in"><br/>
      <br/>
      
      </p>
      </body>
      </html>`,

      confirmButtonColor: "#655CC9",
      confirmButtonText: "OK",
      showCloseButton: true,
      focusConfirm: false,
    });
  }
  export default Termdata;